// extracted by mini-css-extract-plugin
export default {"wrap":"hG-z","fullWidth":"iG-z","hideOnDesktop":"jG-z","content":"kG-z","hasOpenedNav":"lG-z","crumbsList":"mG-z","dropdownsWrap":"nG-z"};